import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { useTrustPilot } from "../../hooks/useTrustPilot";
import { useConfig } from "../../providers/useConfig";
export const TrustPilotStars = ({ className, sku, height = "24px", width = "280px" }) => {
    const { isEnabledForTenant, localeCode, businessUnitId, starsWidgetTemplateId, leaveAReviewLink = "", theme, } = useConfig();
    const ref = useRef(null);
    useTrustPilot({ ref, width, height });
    const isMisconfigured = !localeCode || !businessUnitId || !starsWidgetTemplateId;
    if (!isEnabledForTenant || isMisconfigured) {
        return null;
    }
    return (_jsx("div", { ref: ref, "data-testid": "trustpilot-stars", className: className, "data-sku": sku, "data-template-id": starsWidgetTemplateId, "data-locale": localeCode, "data-businessunit-id": businessUnitId, "data-style-height": height, "data-style-width": width, "data-theme": theme, "data-no-reviews": "show", "data-star-color": "#000000", "data-reviewnumber": "5", "data-scroll-to-list": "true", children: _jsx("a", { href: leaveAReviewLink, target: "_blank", rel: "noopener noreferrer", children: "Trustpilot" }) }));
};
//# sourceMappingURL=TrustPilotStars.js.map